(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 54722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(3724);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var global_SEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26350);
/* harmony import */ var hooks_usePublicProtectedRoute__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80288);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98444);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_4__);

__webpack_require__(14473);




var Register = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6819), __webpack_require__.e(2987), __webpack_require__.e(5872), __webpack_require__.e(129), __webpack_require__.e(1107), __webpack_require__.e(6395), __webpack_require__.e(1577), __webpack_require__.e(5436), __webpack_require__.e(2077), __webpack_require__.e(430), __webpack_require__.e(8699), __webpack_require__.e(809), __webpack_require__.e(1977), __webpack_require__.e(8425), __webpack_require__.e(3930), __webpack_require__.e(4868), __webpack_require__.e(1950)]).then(__webpack_require__.bind(__webpack_require__, 91950));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91950)
            ];
        }
    }
});
var AuthLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5900).then(__webpack_require__.bind(__webpack_require__, 25900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25900)
            ];
        }
    }
});
function RegisterPage() {
    (0,hooks_usePublicProtectedRoute__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AuthLayout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_SEO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Register, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (RegisterPage);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://ui.lab.stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.lab.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v25-staging";
var API_VERSION_ALT = "exodus-migration" || 0;
var API_BASE_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.lab.stockbit.com";
var API_TRADING_URL = "https://trading.lab.masonline.id";
var API_TRADING_URL_V2 = "https://trading-core.lab.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api.trading-lab.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.lab.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit-stream-dev.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.sandbox.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.lab.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.com.stockbitdev.ios"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://ui.lab.stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-WWZ885M" || 0;
var siteUrl = "https://ui.lab.stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "TEST-7ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "9961bcff-8da8-43a1-917e-39d352a4a0dd" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 80288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14229);




/**
 * Hooks to redirect user if they have been logged in
 */ function usePublicProtectedRoute() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var checkCredential = function() {
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (localStorage.at && parsedCookie) {
            var token = parsedCookie.accessToken.token;
            return !!token;
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isLoggedIn = checkCredential();
        setLoggedIn(isLoggedIn);
        if (isLoggedIn && !router.asPath.includes("/stream")) {
            window.location.href = "".concat(window.location.origin).concat(constants_app__WEBPACK_IMPORTED_MODULE_2__/* .PROJECT_FOLDER_PATH */ .qV, "/stream");
        }
    }, [
        router
    ]);
    return loggedIn;
}
/* harmony default export */ __webpack_exports__["Z"] = (usePublicProtectedRoute);


/***/ }),

/***/ 98444:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3798,2678,4885,7148,9521,9586,9459,852,4229,9774,2888,179], function() { return __webpack_exec__(54722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);